import * as types from '@/store/spWorkerRegistration/actionTypes';
import { createRunMutationAction } from '@/store/utils';
import * as mutationTypes from '@/store/spWorkerRegistration/mutationsTypes';
// eslint-disable-next-line import/no-cycle
import { createNewSPWorker } from '@/services/repository';
import { REMOVE_SP_WORKER_REGISTRATION_DATA } from '@/store/spWorkerRegistration/mutationsTypes';

export default {
  [types.CHANGE_SP_WORKER_AVATAR]: createRunMutationAction(mutationTypes.SET_SP_WORKER_AVATAR),
  [types.CHANGE_SP_WORKER_CHOSEN_CERTIFICATE]: createRunMutationAction(mutationTypes.SET_SP_WORKER_CERTIFICATIONS_CHOSEN_INFO),
  [types.CHANGE_SP_WORKER_CHOSEN_SERVICES]: createRunMutationAction(mutationTypes.SET_SP_WORKER_SERVICES_CHOSEN_INFO),
  [types.CHANGE_SP_WORKER_GENERAL_INFO]: createRunMutationAction(mutationTypes.SET_SP_WORKER_GENERAL_INFO),
  async [types.CLEAR_SP_WORKER_REGISTRATION_DATA]({ commit }) {
    await commit(mutationTypes.CLEAR_SP_WORKER_AVATAR);
    await commit(mutationTypes.CLEAR_SP_WORKER_CHOSEN_CERTIFICATE);
    await commit(mutationTypes.CLEAR_SP_WORKER_CHOSEN_SERVICES);
    await commit(mutationTypes.CLEAR_SP_WORKER_GENERAL_INFO);
  },
  async [types.REGISTER_SERVICE_PROVIDER_WORKER]({ getters, commit, dispatch }) {
    const {
      firstName,
      lastName,
      jobTitle,
      phoneNumber,
      startWorkingHour,
      endWorkingHour,
      summary,
      workingDays,
      experience,
      hourRate,
      workEmail,
    } = getters.spWorkerGeneralInfo;

    const userData = {
      firstName,
      lastName,
      jobTitle,
      phoneNumber,
      startWorkingHour,
      endWorkingHour,
      summary,
      workingDays,
      experience,
      hourRate,
      workEmail,
      certificationData: getters.spWorkerCertificationsChosen,
      servicesChosen: getters.spWorkerServicesChosen,
      ipAddress: getters.spWorkerGeneralInfo.ipAddress,
      avatar: getters.spWorkerAvatar,
    };
    const result = await createNewSPWorker(userData);
    commit(REMOVE_SP_WORKER_REGISTRATION_DATA);
    dispatch(types.CLEAR_SP_WORKER_REGISTRATION_DATA);
    return result;
  },
};
